import cookie from "js-cookie"
import type {
  MembershipPricingOption,
  PriceWithMembershipOptions,
  PricingOption,
  ProductOnlyPricingOption,
} from "types"
import { isBrowser } from "utils/isBrowser"

export const TYPICAL_JOURNEY_COOKIE = "bp-typical-journey"

const isPreviewOrFeatureEnv = (hostname: string) =>
  /\.beautypie-preview\.com$/.test(hostname)

// When deployed in a feature environment, allow cookies to be set on the whole domain
export const getCookieDomainOverride = (hostname?: string) => {
  try {
    if (hostname && isPreviewOrFeatureEnv(hostname)) {
      return `.beautypie-preview.com`
    }
    return undefined
  } catch (err) {
    console.warn(
      { err },
      `Cannot determine cookie domain for hostname=${hostname}`
    )
    return undefined
  }
}

export const setShowAccessPassPopup = (value: string): void => {
  if (isBrowser()) {
    cookie.set(TYPICAL_JOURNEY_COOKIE, value, {
      domain: getCookieDomainOverride(window.location.hostname),
    })
  }
}

export const getShowAccessPassPopup = (): string | null => {
  if (isBrowser()) {
    return cookie.get(TYPICAL_JOURNEY_COOKIE) ?? null
  }
  return null
}

export const acquisitionKitsMap = {
  "en-GB": {
    "62237": "BP_3M_AUTOUPGRADES_UK",
    "62244": "BP_PLUS_UK",
    "62251": "BP_PLUS_UK",
    "62749": "BP_3M_AUTOUPGRADES_UK",
    "68765": "BP_3M_AUTOUPGRADES_UK",
  },
  "en-US": {
    "62237": "BP_3M_AUTOUPGRADES_US",
    "62244": "BP_PLUS_US",
    "62268": "BP_PLUS_US",
    "62749": "BP_3M_AUTOUPGRADES_US",
    "68765": "BP_3M_AUTOUPGRADES_US",
  },
}

const isSingleMembershipOption = (
  option?: PricingOption
): option is MembershipPricingOption => !!option && "membership" in option

const isPriceWithMembershipOptions = (
  option?: PricingOption
): option is PriceWithMembershipOptions => !!option && "memberships" in option

export const isProductOnlyPricingOption = (
  option?: PricingOption
): option is ProductOnlyPricingOption => {
  if (!option) {
    return true
  }

  if (isSingleMembershipOption(option)) {
    return false
  }
  if (isPriceWithMembershipOptions(option)) {
    return !option?.memberships?.length
  }
  return true
}
